import React, { useState, useEffect,useRef } from "react";
import "./style.scss";
import { EditOutlined, DeleteOutlined, SendOutlined } from "@ant-design/icons";
import { blue, red } from "@ant-design/colors";
import { Layout, Space, Button, Table, Popconfirm, PageHeader, Modal, message } from "antd";
import R2Footer from "../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddDiscounts from "./AddDiscount";
import DiscountService from "../../services/DiscountService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Spinner from "../../components/Layout/Spinner";
import InstaIcon from "../../assets/images/Insta.svg";
import FbIcon from "../../assets/images/Fb.svg";
import TwitterIcon from "../../assets/images/Twitter.svg";
import TiktokIcon from "../../assets/images/Tiktok.svg";
import EmailIcon from "../../assets/images/Email.svg";
import ClipboardIcon from "../../assets/images/Clipboard.svg";
import LinkedinIcon from "../../assets/images/Linkedin.svg";

const { Content } = Layout;

const Discount = (props) => {
  const [addModal, setAddModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [updatedTestimonial, setUpdatedTestimonial] = useState();
  const [discounts, setDiscounts] = useState([]);
  const [defaultPage, setDefaultPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const history = useHistory();
  const [shareUrl, setShareUrl] = useState("")
  const title = 'Hello , A good deal for you.';

  const adminRestaurant = useSelector((state) => state.admin);
  const [isCopied, setIsCopied] = useState(false);
  const handleClick = (event,discount) => {
    if (isCopied) {
      // Prevent default behavior if text has been copied
      event.preventDefault();
      event.stopPropagation();
    } 
    else{
      // history.push(`/discount-codes/${discount.id}`);
    }
  };

  const handleCopyText = (textcopy) => {
    navigator.clipboard.writeText(textcopy).then(() => {
      setIsCopied(true); // Set the state to indicate text is copied
    }).catch(err => {
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return <div className="name_text">{record.name}</div>;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Code",
      dataIndex: "value",
      key: "value",
      render: (_, record) => {
        return (
          <div className="code_text"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation()
            handleCopyText(record?.discount_codes[0]?.code);
            handleClick(event,record);
          }}
          >{record?.discount_codes[0]?.code}</div>
        );
      },
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (_, record) => {
        return (
          <div className="value_text">
            {record.type === "DOLLAR" ? `$${record.value}` : `${record.value}%`}
          </div>
        );
      },
    },
    {
      title: "Valid Till",
      dataIndex: "count_to_check",
      key: "count_to_check",
      render: (_, record) => {
        return (
          <div className="value_tex">
            {record?.discount_codes[0]?.valid_till?.split("T")[0]}
          </div>
        );
      },
    },
    {
      title: "Valid From",
      dataIndex: "count_to_discount",
      key: "count_to_discount",
      render: (_, record) => {
        return (
          <div className="value_tex">
            {record?.discount_codes[0]?.valid_from?.split("T")[0]}
          </div>
        );
      },
    },
    {
      title: "Multiple Use",
      dataIndex: "count_to_discount",
      key: "count_to_discount",
      render: (_, record) => {
        return (
          <div className="value_tex">
            {record?.discount_codes[0]?.is_multi_use ? "Yes" : "No"}
          </div>
        );
      },
    },
    {
      title: "",
      render: (_, record) => {
        return (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
            }}
          >
            {discounts.length > 0 && (
              <>
                <EditOutlined
                  style={{ color: blue[5] }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setUpdatedTestimonial(record);
                    setEdit(true);
                    setAddModal(true);
                    history.push(`/business/edit-discount/${record.id}`);
                  }}
                />{" "}
                &nbsp;&nbsp;
                <SendOutlined 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShareUrl(record?.discount_codes?.map(item => item.code).join(", "))
                  setShareModal(true);
                }}/>
                &nbsp;&nbsp;
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={(e) => {
                    e.stopPropagation();
                    deleteCode(record.id);
                  }}
                >
                  <DeleteOutlined style={{ color: red[5] }} />
                </Popconfirm>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      message.success('Coupon code copied to clipboard!');
    }).catch(err => {
      message.error('Failed to copy coupon code.');
    });
  };

  const handleEmailClick = () => {
    const couponCode = shareUrl;
    const subject = encodeURIComponent('Special Offer: Your Coupon Code Inside!');
    const body = encodeURIComponent(`Hi there,\n\nUse the code ${couponCode} to get offer your next purchase.\n\nBest regards`);
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

    window.location.href = mailtoLink;
  };

  
    const handleLinkedInClick = () => {
      const couponCode = shareUrl;
      const shareUrl = encodeURIComponent('https://yourwebsite.com'); // Replace with your URL
      const shareText = encodeURIComponent(`Use the code ${couponCode} to get off your next purchase!`);
  
      const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}&title=${shareText}`;
  
      window.open(linkedInUrl, '_blank');
    };

    const handleTktokClick = () => {
      const couponCode = shareUrl;
  
      navigator.clipboard.writeText(couponCode).then(() => {
        message.success('Coupon code copied to clipboard!');
        setTimeout(() => {
          window.open('https://www.tiktok.com/', '_blank');
        }, 1000);
      }).catch(err => {
        message.error('Failed to copy coupon code.');
      });
    };

    const handleTwitterClick = () => {
      const couponCode = shareUrl;
      const text = encodeURIComponent(`Use the code ${couponCode} to get off your next purchase! #SpecialOffer`);
      const url = encodeURIComponent('https://yourwebsite.com'); // Replace with your website URL if needed
      const twitterLink = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  
      window.open(twitterLink, '_blank');
    };

    const handleFacebookShareClick = () => {
      const couponCode = shareUrl;
      const url = 'https://your-website.com'; // Replace with the URL you want to share
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(`Use the code ${couponCode} to get off your next purchase.`)}`;
  
      window.open(shareUrl, '_blank', 'width=600,height=400');
    };

    const handleCopyAndOpenInstagram = () => {
      // Copy the coupon code to clipboard
      navigator.clipboard.writeText(shareUrl).then(() => {
        message.success('Coupon code copied to clipboard! Opening Instagram...');
        // Open Instagram app or website
        window.open('https://www.instagram.com/', '_blank');
      }).catch(err => {
        message.error('Failed to copy coupon code.');
      });
    };

  const [isSelecting, setIsSelecting] = useState(false);
  const mouseDownRef = useRef(null);

  const handleMouseDown = (e) => {
    mouseDownRef.current = { x: e.clientX, y: e.clientY };
    setIsSelecting(false);
  };

  const handleMouseMove = () => {
    setIsSelecting(true);
  };
  const handleMouseUp = (e, record) => {
    e.preventDefault()
    const distanceX = Math.abs(e.clientX - mouseDownRef.current.x);
    const distanceY = Math.abs(e.clientY - mouseDownRef.current.y);

    if (!isSelecting && distanceX < 5 && distanceY < 5) {
      // If mouse movement is minimal and not selecting text, consider it a click
      handleRowClick(record);
    }
  };

  const handleRowClick = (discount) => {
    // Perform the redirection here
    history.push(`/discount-codes/${discount.id}`);
  };

  const deleteCode = async (id) => {
    await DiscountService.deleteDiscounts(id);
    getDiscounts();
  };

  useEffect(() => {
    getDiscounts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeModal = (status) => {
    setAddModal(status);
    getDiscounts();
  };

  const getDiscounts = async (page=1) => {
    setLoading(true)
    const data = await DiscountService.getDiscounts(adminRestaurant,page);
    setDiscounts(data?.discounts);
    setTotalPage(data?.total);
    setLoading(false)
  };

  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
            title="Discounts"
            className="page-header-business"
            extra={[
              <Button
                type="primary"
                className="custom-btn"
                onClick={() => {
                  // setEdit(false)
                  history.push(`/business/add-discount`);
                  // setAddModal(true)
                }}
              >
                Add Discount
              </Button>,
            ]}
          />
          <div className="content-container-business box-shadow-card">
            <Table
              columns={columns}
              dataSource={discounts}
              style={{padding:"4px 0px"}}
              className="discount-table overflow-auto"
              pagination={{
                onChange: (page) => {
                  setDefaultPage(page);
                  getDiscounts( page );
                },
                current: defaultPage,
                pageSize: 10,
                total: totalPage,
                hideOnSinglePage: true,
                showSizeChanger: false,
              }}
              // onRow={(record) => ({
              //   onMouseDown: handleMouseDown,
              //   onMouseMove: handleMouseMove,
              //   onMouseUp: (e) => handleMouseUp(e, record),
              // })}
              onRow={(discount) => {
                return {
                  onClick: (event) => {
                    event.preventDefault();
                    event.stopPropagation()
                    history.push(`/discount-codes/${discount.id}`);
                  },
                };
              }}
            />
          </div>
        </Space>
      </Content>
      {isLoading &&
      <Spinner/>}
      <R2Footer />
      {addModal && (
        <AddDiscounts
          modalOpen={true}
          isEdit={isEdit}
          closeModal={closeModal}
          updatedTestimonial={updatedTestimonial}
        />
      )}
      <Modal
     width={630}
      onCancel={() => {
       
        setShareModal(false)
      }}
      footer={null}
      open={shareModal}
    >
      <div>
      <div>
      <img src={InstaIcon} alt="check" style={{ margin: ".5rem" ,cursor:"pointer"}} 
      onClick={handleCopyAndOpenInstagram}/>
      <img src={FbIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }}
      onClick={handleFacebookShareClick} />

      <img src={TwitterIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }} 
      onClick={handleTwitterClick}/>

      <img src={TiktokIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }}
      onClick={handleTktokClick} />

      <img src={LinkedinIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }} 
      onClick={handleLinkedInClick}/>

      <img src={EmailIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }}
      onClick={handleEmailClick} />

      <img src={ClipboardIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer" }}
      onClick={handleCopy} />


    </div>
      </div>

    </Modal>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Discount));
